import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import EditSlider from './EditSlider';
import RenderTab from './RenderTab';
import { getUserDetailApi } from '../../api/usersApi';

const EditUser = ({ setEdit, ref, selectedUser, isEditUser, type = "", handleActionUser, isSuspendLoading, setSelectUser, setPersonalEmail, personalEmail, handleUpdateUser, isSaveLoading, setIsSaveLoading, registedEmail, setRegistedEmail, handleUpdateTeamUser, setReason, reason }) => {

    const [editProfiledata, setEditProfiledata] = useState();
    const [isLoadingData, setIsLoadingData] = useState(true);

    const getAngel = useSelector((state) => state.angels.singleAngel);
    const getVc = useSelector((state) => state.vcs.singleVc);
    const getAccelerator = useSelector((state) => state.accelerators.singleAccelerator);

    useEffect(() => {
        if (selectedUser?.userId) {
            const fetchData = async () => {
                try {
                    setIsLoadingData(true)
                    const response = await getUserDetailApi(selectedUser?.userId)
                    if (response) {
                        setEditProfiledata(response)
                    }
                } catch (error) {
                    console.log(error);
                    setIsLoadingData(false)
                }
            }
            fetchData();
        }
    }, [selectedUser?.userId]);

    useEffect(() => {
        if (editProfiledata && editProfiledata !== undefined) {
            setTimeout(() => {
                setIsLoadingData(false);
            }, 4000);
        }
    }, [editProfiledata]);

    useEffect(() => {
        if (!isEditUser) {
            setSelectUser({})
        }
    }, [isEditUser])

    const profileClassMap = {
        vc: 'vcProfile-popup',
        accelerator: 'accelratorProfile-popup',
        angel: 'angelProfile-popup',
        founder: 'founderProfile-popup'
    };

    const profilePopup = profileClassMap[type] || 'founderProfile-popup';

    const LazyImage = ({ src, alt }) => {
        const [isVisible, setIsVisible] = useState(false);
        const imgRef = useRef();

        useEffect(() => {
            const observer = new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                        observer.disconnect();
                    }
                },
                { threshold: 0.1 }
            );

            if (imgRef.current) {
                observer.observe(imgRef.current);
            }

            return () => {
                if (imgRef.current) {
                    observer.unobserve(imgRef.current);
                }
            };
        }, []);

        return (
            <img
                ref={imgRef}
                src={src}
                data-src={src}
                alt={alt}
            />
        );
    };

    return (
        <>
            <div className={`${isEditUser && 'founder-popup-overlay popup-overlay'}`}></div>
            <div className={`profile-popup ${profilePopup} ${isEditUser ? 'show' : ''}`} ref={ref}>
                <div className='popup-box'>
                    <div className="popup-close" onClick={() => { setEdit(false); setSelectUser({}) }}>
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 1L1 13M1 1L13 13" stroke="#05171A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <div
                        className={`pagesTable dataTable-list ${isLoadingData ? 'loading-list profile-data-loader' : ''
                            }`}
                    >
                        <EditSlider
                            profileData={editProfiledata?.profile}
                            LazyImage={LazyImage}
                        />

                        <RenderTab
                            selectedUser={selectedUser}
                            profileData={editProfiledata?.profile}
                            startupData={editProfiledata?.company}
                            coFounderData={editProfiledata?.coFounders}
                            getAngel={getAngel}
                            setEdit={setEdit}
                            getVc={getVc}
                            getAccelerator={getAccelerator}
                            handleActionUser={handleActionUser}
                            isSuspendLoading={isSuspendLoading}
                            userActivity={editProfiledata?.userActivity}
                            adminHistory={editProfiledata?.adminActivity}
                            reportList={editProfiledata?.reports}
                            setSelectUser={setSelectUser}
                            personalEmail={personalEmail}
                            setPersonalEmail={setPersonalEmail}
                            handleUpdateUser={handleUpdateUser}
                            isSaveLoading={isSaveLoading}
                            setIsSaveLoading={setIsSaveLoading}
                            setRegistedEmail={setRegistedEmail}
                            registedEmail={registedEmail}
                            handleUpdateTeamUser={handleUpdateTeamUser}
                            reason={reason}
                            setReason={setReason}
                            LazyImage={LazyImage}
                            isEditUser={isEditUser}
                        />
                    </div>
                </div>
                <div>
                </div>
            </div>
        </>
    )
}

export default EditUser